// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2NEz2","inner":"Form_inner__3qOxh","range":"Form_range__Tz7Jk","name":"Form_name__3Y-ku","actions":"Form_actions__2x9Vs"};